<div class="amenitiesDetail__content">
  <div class="amenitiesDetail__content__item" *ngFor="let amenity of amenities">
    <img *ngIf="amenity.Icon" loading="lazy" [alt]="amenity.Name" [src]="amenity.Icon | baseImage : amenitiesBasePath">
    <span *ngIf="!amenity.Icon" class="img-not-found">●</span>
    <span>{{ amenity.Name }}</span>
  </div>
</div>